import { render, staticRenderFns } from "./HubDetail.pug?vue&type=template&id=d835065a&lang=pug&external"
import script from "./HubDetail.js?vue&type=script&lang=js&external"
export * from "./HubDetail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports